import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQueryWithCsrf } from "./baseQueryWithCsrf";

export const bookingApi = createApi({
    reducerPath: 'orderApi',
    baseQuery: baseQueryWithCsrf,
    tagTypes: ['Order', "AdminOrders"],
    keepUnusedDataFor: 60,
    endpoints: (builder) => ({

        createNewOrder: builder.mutation({
            query(body) {
                return{
                    url: "/orders/new",
                    method: "POST",
                    body,
                }
            },
        }),

        myOrders: builder.query({
          query: () => `/me/orders`,
      }),

  
        orderDetails: builder.query({
          query: (id) => `/orders/${id}`,
          providesTags: (result, error, id) => [{ type: 'Order', id }],
        }),

      getAdminOrders: builder.query({
        query: () => `/admin/orders`,
        providesTags: ["AdminOrders"],
      }),
      


    updateOrder: builder.mutation({
      query({ id, body }) {
        return {
          url: `/admin/orders/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Order"],
    }),

    updateMyOrder: builder.mutation({
      query({ id, body }) {
        return {
          url: `me/booking/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Order"],
    }),

    deleteOrder: builder.mutation({
      query(id) {
        return {
          url: `/admin/orders/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["AdminOrders"],
    }),

    deleteMyOrder: builder.mutation({
      query(id) {
        return {
          url: `/me/booking/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["AdminOrders"],
    }),

        finishBookingUser: builder.mutation({
      query({ id, body }) {
        return {
          url: `me/booking/finish/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Order"],
    }),

    }),
  });


export const { 
  useCreateNewOrderMutation,
  useMyOrdersQuery,
  useOrderDetailsQuery,
  useGetAdminOrdersQuery, 
  useUpdateOrderMutation,
  useDeleteOrderMutation,
  useDeleteMyOrderMutation,
  useUpdateMyOrderMutation,
  useFinishBookingUserMutation,
} = bookingApi;